import { ReportTypes } from '@mode/shared/contract-common';
import { ReportDomain } from '@mode/shared/contract-common';
import {
  ReportResource,
  ReportRunFormFieldOptionsResource,
  CreateReportWithDatasetResponse,
  ReportDbtMetaDataResponse,
} from '../reports/report-response.types';

export function toReport(resource: ReportResource): ReportDomain.Report {
  return {
    token: resource.token,
    description: resource.description,
    name: resource.name,
    layout: resource.layout,
    last_run_at: resource.last_run_at,
    orgName: resource.account_username,
    hasSuccessfulReportRun: !!resource.last_successfully_run_at,
    isViewable: (resource._embedded?.['space'] as any)?.['viewable?'],
    iFrameSrc: (resource._embedded?.['display_properties'] as any)?.iframe_src,
    shared: !!resource.last_run_at,
    drillAnywhereEnabled: resource.drill_anywhere_enabled,
    manualRunDisabled: resource.manual_run_disabled,
    theme: resource._embedded?.['report_theme']
      ? {
          name: (resource._embedded['report_theme'] as any).name,
          token: (resource._embedded['report_theme'] as any).token,
          href: (resource._embedded['report_theme'] as any).css_href,
          customSource: (resource._embedded['report_theme'] as any).css_source,
        }
      : {
          // fallback theme
          name: 'Fallback',
          token: 'fallback_theme',
          href: (window as any).ASSET_PATH_MAP?.embedReportCSS, // can't reference asset service from Angular
          customSource: undefined,
        },
    thoughtspotPublishedAt: resource.thoughtspot_published_at,
    creatorName: (resource._embedded?.['creator'] as any)?.name,
    spaceDefaultAccess: (resource._embedded?.['space'] as any)?.default_access_level,
    spaceName: (resource._embedded?.['space'] as any)?.name,
    spaceType: (resource._embedded?.['space'] as any)?.space_type,
    spaceToken: (resource._embedded?.['space'] as any)?.token,
  };
}

export function toReportParameterOptions(
  resource: ReportRunFormFieldOptionsResource
): ReportDomain.ReportRunFormFieldOptions {
  const r: ReportDomain.ReportRunFormFieldOptions = {
    name: resource.name,
    options: resource.options,
    optionsError: resource.options_error,
    sourceSize: resource.source_size,
  };
  return r;
}

export function toReportWithDatasetResponse(resource: CreateReportWithDatasetResponse) {
  return {
    token: resource.token,
  };
}

export function toDbtMetadata(dbtMetadataResource: ReportDbtMetaDataResponse): ReportTypes.ReportDbtMetaData {
  const dbtMetaDataValue: ReportTypes.ReportDbtMetaData = {
    lastEdit: dbtMetadataResource.edited_at,
    views: dbtMetadataResource.view_count,
    lastSuccessfulRun: dbtMetadataResource.last_successfully_run_at,
    message: dbtMetadataResource.message,
    sourceDataLastLoadedAt: dbtMetadataResource.source_data_last_loaded_at,
    state: dbtMetadataResource.state,
    tables: dbtMetadataResource.tables.map((table) => ({
      name: table.name,
      sourceDataLastLoadedAt: table.source_data_last_loaded_at,
      details: table.details,
      oldestSource: table.oldest_source,
    })),
  };

  return dbtMetaDataValue;
}
